
import type { SVGProps } from 'react';
const SvgRelax = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#relax_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M10.211 15.904c-.18 0-.35-.005-.518-.01l7.319-5.81c-1.418 2.651-3.75 5.82-6.8 5.82m8.306-7.178c.002-.025-.003-.049-.006-.073-.003-.025-.004-.05-.013-.073-.008-.026-.023-.049-.037-.072-.01-.017-.014-.035-.026-.05q-.006-.005-.011-.009-.026-.027-.06-.049c-.02-.016-.04-.034-.064-.045l-.01-.008c-.018-.008-.036-.007-.053-.012-.028-.008-.054-.017-.083-.018-.024-.002-.047.003-.071.006-.026.003-.051.004-.077.013-.025.008-.047.023-.07.036-.018.01-.036.014-.052.026l-9.332 7.406c-2.201-.279-3.065-1.05-3.087-1.071a.395.395 0 0 0-.552.007.384.384 0 0 0 .004.548c.043.042.837.79 2.81 1.171L5.899 17.91a.385.385 0 0 0-.061.545.393.393 0 0 0 .55.06l2.4-1.904c.433.043.904.069 1.423.069q.204 0 .404-.017l5.082 1.912a.392.392 0 0 0 .506-.224.386.386 0 0 0-.228-.5l-3.951-1.487c2.963-1.047 5.11-4.516 6.463-7.505.008-.017.007-.035.012-.053.008-.027.017-.052.018-.08m-9.77-.745c0 .536-.44.972-.982.972a.98.98 0 0 1-.983-.972c0-.537.44-.973.983-.973s.982.436.982.973m-3.356.522h.696c.05.157.115.306.205.44l-.543.538a.347.347 0 0 0 0 .495.354.354 0 0 0 .5 0l.543-.538c.168.11.357.19.558.237v.767a.39.39 0 0 0 .392.388.39.39 0 0 0 .392-.388V9.69q.331-.07.604-.251l.543.538a.355.355 0 0 0 .5 0 .347.347 0 0 0 0-.495l-.543-.538c.089-.134.154-.283.204-.44h.651a.39.39 0 0 0 .392-.388.39.39 0 0 0-.392-.387h-.588a1.7 1.7 0 0 0-.268-.71l.544-.538a.35.35 0 0 0 0-.495.357.357 0 0 0-.5 0l-.543.538a1.8 1.8 0 0 0-.604-.251v-.483a.39.39 0 0 0-.392-.388.39.39 0 0 0-.392.388v.497c-.201.048-.39.127-.558.237l-.544-.538a.357.357 0 0 0-.5 0 .35.35 0 0 0 0 .495l.544.538c-.14.209-.23.45-.268.71h-.633A.39.39 0 0 0 5 8.115a.39.39 0 0 0 .392.388"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="relax_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRelax;
